import React from 'react';
import StatusCheckerView from '../views/StatusCheckerView/StatusCheckerView';
import MainContainer, { IMainContainerProps } from './MainContainer';

const RootContainer: React.FC<React.PropsWithChildren<IMainContainerProps>> = ({
  settings,
  currentUser,
}) => (
  <MainContainer settings={settings} currentUser={currentUser}>
    <StatusCheckerView />
  </MainContainer>
);

export default RootContainer;
